import React from "react";
import { Eye } from "lucide-react";
import { LaunchableViewAccessSelector } from "../../shared/LaunchableViewAccessSelector";
import type { AccessLevel } from "../../shared/LaunchableAccessControl";
import { SectionIcon } from "../layout";

export const ViewAccessSection: React.FC<{
  isEditMode: boolean;
  viewAccess: AccessLevel;
  onViewAccessChange: (value: AccessLevel) => void;
  loadingCreatingLaunchable: boolean;
}> = ({
  isEditMode,
  viewAccess,
  onViewAccessChange,
  loadingCreatingLaunchable,
}) => (
  <section
    id={isEditMode ? "edit-launchable" : "create-launchable"}
    className="scroll-mt-4 rounded-md border border-zinc-800 bg-primaryBg p-4"
  >
    <div className="flex items-center gap-3">
      <SectionIcon icon={<Eye className="h-5 w-5" />} />
      <h2 className="text-base font-semibold text-primary">View access</h2>
    </div>

    <div className="mt-4 border-t border-zinc-800 pt-4">
      <LaunchableViewAccessSelector
        value={viewAccess}
        onChange={onViewAccessChange}
        label={null}
        disabled={loadingCreatingLaunchable}
      />
    </div>
  </section>
);
